import _slicedToArray from "/home/circleci/project/website/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { pipe, toPairs, map, fromPairs } from 'lodash/fp';
/**
 * Transforms object by converting keys to values and values to keys
 *
 * @param {object} input
 * @returns {object} output
 *
 * @example
 * flipObject({ foo: 'bar' }) // returns { bar: 'foo' }
 */

export var flipObject = pipe([toPairs, map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      a = _ref2[0],
      b = _ref2[1];

  return [b, a];
}), fromPairs]);
export default flipObject;